import type { DiscountFlagCampaignConfig } from '~/index'

export function isDiscountFlagActive(flag: DiscountFlagCampaignConfig, now: number): boolean {
  if (!flag.startDate || !flag.endDate)
    return false

  const start = Date.parse(flag.startDate)
  // Append end-of-day so the flag stays visible through the entire end date.
  const end = Date.parse(`${flag.endDate}T23:59:59`)

  if (Number.isNaN(start) || Number.isNaN(end))
    return false

  return start <= now && now <= end
}

export function resolveDiscountFlagPercent(
  flags: Record<string, DiscountFlagCampaignConfig>,
  supplierHandle: string | undefined,
  now: number,
): number | undefined {
  if (!supplierHandle)
    return undefined

  return Object.values(flags)
    .filter(flag => isDiscountFlagActive(flag, now))
    .find(flag => flag.supplierHandle === supplierHandle)
    ?.discountPercent
}

export const useDiscountFlag = () => {
  const { discountFlagCampaigns } = useCountryConfig()
  const now = Date.now()

  const getDiscountFlagPercent = (supplierHandle?: string): number | undefined =>
    resolveDiscountFlagPercent(discountFlagCampaigns ?? {}, supplierHandle, now)

  return { getDiscountFlagPercent }
}
